import { ArrowRight, Phone } from "@phosphor-icons/react";

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/sx6zv4pe_Equipo.jpeg";

export function HeroSection() {
  const handleCTAClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center pt-20 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-slate-100" />
      
      {/* Grid Pattern */}
      <div 
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `linear-gradient(#0F172A 1px, transparent 1px), linear-gradient(90deg, #0F172A 1px, transparent 1px)`,
          backgroundSize: '60px 60px'
        }}
      />

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="space-y-8 animate-fade-in-up">
            {/* Overline */}
            <div className="flex items-center gap-3">
              <span className="w-12 h-0.5 bg-[#C92127]" />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
                SEINMAR S.A.S.
              </span>
            </div>

            {/* Headline */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-slate-900 leading-[1.05]">
              Obra civil y{" "}
              <span className="text-[#C92127]">mantenimiento industrial</span>
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-slate-600 max-w-xl leading-relaxed">
              Soluciones integrales con enfoque en seguridad, cumplimiento y 
              continuidad operativa para instalaciones comerciales e industriales.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href="#contacto"
                onClick={(e) => handleCTAClick(e, "#contacto")}
                className="btn-primary inline-flex items-center justify-center gap-2 group"
                data-testid="hero-cta-primary"
              >
                Solicitar Cotización
                <ArrowRight 
                  size={20} 
                  weight="bold" 
                  className="transition-transform group-hover:translate-x-1" 
                />
              </a>
              <a
                href="tel:+573233230210"
                className="btn-secondary inline-flex items-center justify-center gap-2"
                data-testid="hero-cta-phone"
              >
                <Phone size={20} weight="bold" />
                323 323 0210
              </a>
            </div>

            {/* Stats */}
            <div className="flex gap-8 pt-8 border-t border-slate-200">
              <div>
                <p className="text-3xl md:text-4xl font-extrabold text-slate-900">10+</p>
                <p className="text-sm text-slate-500 uppercase tracking-wider">Clientes Industriales</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-extrabold text-slate-900">5+</p>
                <p className="text-sm text-slate-500 uppercase tracking-wider">Servicios Integrales</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-extrabold text-[#C92127]">100%</p>
                <p className="text-sm text-slate-500 uppercase tracking-wider">Compromiso</p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative animate-slide-in-left" style={{ animationDelay: "0.2s" }}>
            <div className="relative">
              {/* Main Image */}
              <div className="relative rounded-lg overflow-hidden shadow-2xl">
                <img
                  src={HERO_IMAGE}
                  alt="Equipo SEINMAR trabajando en instalaciones industriales"
                  className="w-full h-[400px] lg:h-[550px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent" />
              </div>

              {/* Floating Card */}
              <div className="absolute -bottom-6 -left-6 bg-[#C92127] text-white p-6 rounded-lg shadow-xl hidden md:block">
                <p className="text-xs uppercase tracking-[0.2em] text-white/80 mb-1">Servicio</p>
                <p className="text-xl font-bold">Profesional</p>
              </div>

              {/* Accent */}
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-[#C92127]/10 rounded-full blur-2xl" />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-xs uppercase tracking-[0.2em] text-slate-400">Scroll</span>
        <div className="w-0.5 h-8 bg-gradient-to-b from-[#C92127] to-transparent" />
      </div>
    </section>
  );
}

export default HeroSection;
